export class DocumentTypeConstant {
    static readonly PROJECT_DOCS = 'Project Docs';
    static readonly ITEM_DOCS = 'Item Docs';
}
